import { PowerMeterDto } from '../dto/power-meter.dto'
import { PowermeterHardwareModel } from '../models/power-meter.model'

const fromHardwareDtoToModelTransformer = (dto: PowerMeterDto): PowermeterHardwareModel => ({
  id: dto.id,
  moduleName: dto.moduleName,
  deviceId: dto.deviceID?.[1],
  AdeVersion: dto.ADE_Version?.[1],
  bootLoader: dto.bootloader?.[1],
  eliminatePhase0: dto.EliminatePhase0?.[1],
  eliminatePhase1: dto.EliminatePhase1?.[1],
  eliminatePhase2: dto.EliminatePhase2?.[1],
  eliminatePhase3: dto.EliminatePhase3?.[1],
  ID: dto.ID?.[1],
  modelType: dto.modelType?.[1],
  name: dto.name?.[1],
  softwareVersion: dto.softwareVersion?.[1],
  type: dto.type?.[1],
  weatherForecastActive: Boolean(dto.weatherForecastActive?.[1]),
  ratioCt: dto.ratioCT?.[1],
  useCt: Boolean(dto.useCT?.[1]),
  address: dto.address?.[1],
  media: dto.media?.[1],
  kind: dto.kind?.[1],
  peakPower: dto.peakPower?.[1],
  subType: dto.subType?.[1],
  deviceType: dto.deviceType?.[1],
  serialnumber: dto.serialno,
})

export default fromHardwareDtoToModelTransformer
